import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"
import { HousingTypeEnum, HeatingTypeEnum, TarificationIdEnum, CustomerTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import { GenericTypeFormatTranslator, TarificationFormat, HeatingTypeFormat, HousingTypeFormat } from "../../../../../Scripts/inpulse/FormatUtils";
import { TranslateResult } from "vue-i18n";

@Component({
    components: { }
})

export default class PreProductSelectionDisplay extends Vue {
    @Prop()
    public contract: any;

    HousingTypeEnum: typeof HousingTypeEnum = HousingTypeEnum;
    HeatingTypeEnum: typeof HeatingTypeEnum = HeatingTypeEnum;
    TarificationIdEnum: typeof TarificationIdEnum = TarificationIdEnum;
    CustomerTypeEnum: typeof CustomerTypeEnum = CustomerTypeEnum;
    get houseArea(): number { return this.$store.state.contract.HouseArea; }

    constructor() {
        super();
    }

    get showEnergy2Consumption(): boolean {
        return this.$store.state.contract.TarificationId == TarificationIdEnum.DAYNIGHTTARIF || this.$store.state.contract.TarificationId == TarificationIdEnum.SEASONTARIF;
    }

    join(separator: string, strs: string[]) {
        const arr = [];
        strs.forEach(s => {
            if (s != null && s.length != 0)
                arr.push(s);
        });
        return arr.join(separator);
    }

    formatPostal(postalCode: string, postOffice: string) {
        const str = this.join(", ", [postalCode, postOffice]);
        return str;
    }

    heatingTypeString(type: HeatingTypeEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(HeatingTypeFormat.toString, type, this.$i18n);
    }

    housingTypeString(type: HousingTypeEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(HousingTypeFormat.toString, type, this.$i18n);
    }

    tarificationTypeString(type: TarificationIdEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(TarificationFormat.toString, type, this.$i18n);
    }

    houseAreaString(): string {
        let retVal = "";
        switch (this.houseArea) {
            case 20:
                retVal = "1 - 40"
                break;
            case 60:
                retVal = "41 - 80"
                break;
            case 100:
                retVal = "81 - 120"
                break;
            case 145:
                retVal = "121 -"
                break;
        }
        return retVal;
    }
}